// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mobileTrackerUrl: 'http://pubads.g.doubleclick.net/gampad/',
  budgetcalcUrl: 'http://localhost:4200/#',
  taxRate: 19,
  minPrepayment: 100,
  maxLengthFreeText: 50,
  startpagepaths: {
    "online": "dias-personaldata",
    "budget": "beforewestart",
    "choice": "userchoice"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
